import { render, staticRenderFns } from "./MyTariff.vue?vue&type=template&id=bc267858&scoped=true"
import script from "./MyTariff.vue?vue&type=script&lang=ts"
export * from "./MyTariff.vue?vue&type=script&lang=ts"
import style0 from "./MyTariff.scss?vue&type=style&index=0&id=bc267858&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc267858",
  null
  
)

export default component.exports